export const INVALID_NUMBER = 'Invalid phone number';
export const NUMBER_ALREADY_CALLED_911 = 'This number has already called 911';
export const EXISTING_CONVERSATION =
  'A conversation with this number already exists';
export const MESSAGE_FAILED_TO_SEND = 'Message failed to send';
export const ROADSIDE_ASSISTANCE_FAILED =
  'Roadside assistance request failed. ';

export const ROADSIDE_ASSISTANCE_ERROR = 'roadside_assistance_error';
export const INVALID_NUMBER_ERROR = 'invalid_number_error';
export const MSG_REQUEST_ERROR = 'msg_request_error';
export const EXISTING_CONVERSATION_ERROR = 'existing_conversation_error';
